export enum ApiErrorCodeEnum {
    // COMMON SECTION
    InvalidModelState = 1000, // Http-Status-Code: 400
    NotAuthorized = 1001, // Http-Status-Code: 403
    MissingName = 1002, // Http-Status-Code: 400
    NameExists = 1003, // Http-Status-Code: 400
    LicenseExpired = 1004, // Http-Status-Code: 403
    InvalidArgument = 1005, // Http-Status-Code: 400
    ManipulatedData = 1006, // Http-Status-Code: 403
    Failed = 1007, // Http-Status-Code: 500
    LeadsToNonAdministrableState = 1008, // Http-Status-Code: 500
    InvalidName = 1009, // Http-Status-Code: 400
    IconNotFound = 1010, // Http-Status-Code: 400
    TimeoutExceeded = 1011, // Http-Status-Code: 504

    // DOCUMENT SECTION
    CannotCreateNonExistingName = 2000, // Http-Status-Code: 400
    NameExistsAndIsCheckedOutByOther = 2001, // Http-Status-Code: 400
    NameExistsAndIsCheckedOutByMyself = 2002, // Http-Status-Code: 400
    NameExistsAndIsTrashed = 2003, // Http-Status-Code: 400
    NameExistsAndIsInProgress = 2004, // Http-Status-Code: 400
    InvalidClassificationValues = 2005, // Http-Status-Code: 400
    NotAuthorizedForClassification = 2006, // Http-Status-Code: 403
    ReachedMaxDocuments = 2007, // Http-Status-Code: 403
    CheckedOutDocumentNotFound = 2008, // Http-Status-Code: 400
    ReachedStorageLimit = 2009, // Http-Status-Code: 403
    ContentWithSameFileExistsInGroup = 2010, // Http-Status-Code: 400
    ContentDoesNotExist = 2011, // Http-Status-Code: 400
    ContentIsCurrentlyNotEditable = 2012, // Http-Status-Code: 400
    VisualStampedContentNotEditable = 2013, // Http-Status-Code: 400
    SignedContentNotEditable = 2014, // Http-Status-Code: 400
    InvalidFileCreateDate = 2015, // Http-Status-Code: 400
    InvalidFileChangeDate = 2016, // Http-Status-Code: 400
    DocumentFileNotFound = 2017, // Http-Status-Code: 400
    TrashedDocumentNotFound = 2018, // Http-Status-Code: 400
    DocumentIsNotLocked = 2019, // Http-Status-Code: 400
    DocumentIsLockedByOtherUser = 2020, // Http-Status-Code: 400
    AbortedByStampAction = 2021, // Http-Status-Code: 400
    ArchivationIsNotAuthorizedForContent = 2022, // Http-Status-Code: 403
    CannotStampArchiveDate = 2023, // Http-Status-Code: 400
    ContentIsNotInStampableState = 2024, // Http-Status-Code: 400
    InvalidPageNumber = 2025, // Http-Status-Code: 400
    StampIsNotAuthorizedForContent = 2026, // Http-Status-Code: 400
    StampedValueIsNotAllowed = 2027, // Http-Status-Code: 400
    CheckOutAndSplitNotAllowed = 2028, // Http-Status-Code: 400
    MissingFileImportPath = 2029, // Http-Status-Code: 400
    DocumentExtensionIsNotEditable = 2030, // Http-Status-Code: 400
    DocumentIsCheckedOut = 2031, // Http-Status-Code: 400
    DocumentNotFound = 2032, // Http-Status-Code: 400
    InvalidStampActionResponse = 2033, // Http-Status-Code: 400
    DocumentAssignmentNotFound = 2034, // Http-Status-Code: 400
    DocumentAssignmentTypeNotDeletable = 2035, // Http-Status-Code: 400
    StampInputRequired = 2036, // Http-Status-Code: 400
    InvalidContent = 2037, // Http-Status-Code: 400
    InvalidDocumentId = 2038, // Http-Status-Code: 400
    ContentWithSameStreamExistsInGroup = 2039, // Http-Status-Code: 400
    DocumentDeleted = 2040, // Http-Status-Code: 400
    NotCheckedOut = 2041, // Http-Status-Code: 400
    CheckedOutByOtherUser = 2042, // Http-Status-Code: 400
    IsStampedOrSigned = 2043, // Http-Status-Code: 400
    DocumentTrashed = 2044, // Http-Status-Code: 400
    DocumentManipulated = 2045, // Http-Status-Code: 400
    DocumentInProgress = 2046, // Http-Status-Code: 400
    DocumentVersionChanged = 2047, // Http-Status-Code: 400
    DocumentArchived = 2048, // Http-Status-Code: 400
    SetDocumentLockFailed = 2049, // Http-Status-Code: 400
    StampNotVisual = 2050, // Http-Status-Code: 400
    StampNotFound = 2051, // Http-Status-Code: 400
    DocumentNotTrashed = 2052, // Http-Status-Code: 400
    ImageConversionNotFound = 2053, // Http-Status-Code: 400
    ErrorGettingStampFields = 2054, // Http-Status-Code: 400
    DocumentPreviewNotFound = 2055, // Http-Status-Code: 400
    DeactivatedDocumentType = 2056, // Http-Status-Code: 400
    StampWithDuplicatedMmsNotUseable = 2057, // Http-Status-Code: 400
    DocumentAssignmentAlreadyExists = 2058, // Http-Status-Code: 400

    // VAULT SECTION
    InvalidGroupId = 3000, // Http-Status-Code: 400
    CannotRemoveUserThatIsUsedInDefaultSelection = 3001, // Http-Status-Code: 400
    GroupMemberNotFound = 3002, // Http-Status-Code: 400
    VaultNotFound = 3003, // Http-Status-Code: 400
    ArchivedContentNotDeletable = 3004, // Http-Status-Code: 400
    CopyingInProgress = 3005, // Http-Status-Code: 400
    InvalidInvitationPin = 3006, // Http-Status-Code: 400

    // MAGNET SECTION
    InvalidMagnetId = 4000, // Http-Status-Code: 400
    ErrorCreatingMagnet = 4001, // Http-Status-Code: 400
    ErrorGettingMagnetsByIds = 4002, // Http-Status-Code: 400
    ReturnedExisting = 4003, // Http-Status-Code: 400
    MagnetNotFound = 4004, // Http-Status-Code: 400
    CurrentlyNotDeletable = 4005, // Http-Status-Code: 400
    ReferencesExist = 4006, // Http-Status-Code: 400
    ConditionTypeObsolete = 4007, // Http-Status-Code: 400
    ConditionIsNotUsableWithMagnets = 4008, // Http-Status-Code: 400

    // TAG SECTION
    InvalidSortFieldId = 5000, // Http-Status-Code: 400
    PropertyGroupNotFound = 5001, // Http-Status-Code: 400
    PropertyDoesNotExist = 5002, // Http-Status-Code: 400
    NotAllowed = 5003, // Http-Status-Code: 403
    InputRequired = 5004, // Http-Status-Code: 400
    InputRequiredForOther = 5005, // Http-Status-Code: 400
    InvalidTagValue = 5006, // Http-Status-Code: 400
    InvalidSelection = 5007, // Http-Status-Code: 400
    InvalidPropertyDefinitionId = 5008, // Http-Status-Code: 400
    ValueNodeWithSameNameAlreadyExists = 5009, // Http-Status-Code: 400
    ValueWithSameNameAlreadyExists = 5010, // Http-Status-Code: 400
    CannotRemoveSelectionValueNodeWithReferences = 5011, // Http-Status-Code: 400
    CannotRemoveDocTypeCategoryWithReferences = 5012, // Http-Status-Code: 400
    CannotRemoveDocTypeWithReferences = 5013, // Http-Status-Code: 400
    CannotAddValueNodeToDeactivatedParent = 5014, // Http-Status-Code: 400
    PropertyGroupDefinitionWithSameNameAlreadyExists = 5015, // Http-Status-Code: 400
    PropertyGroupDefinitionNotFound = 5016, // Http-Status-Code: 400
    TagDefinitionNotFound = 5017, // Http-Status-Code: 400
    FieldAlreadyExists = 5018, // Http-Status-Code: 400
    CaptionIsNull = 5019, // Http-Status-Code: 400
    DuplicatedCaption = 5020, // Http-Status-Code: 400
    CannotRemovePropertyDefinitionWithArchivedContent = 5021, // Http-Status-Code: 400
    CannotRemovePropertyDefinitionWithReferences = 5022, // Http-Status-Code: 400
    TypeChangeNotAllowed = 5023, // Http-Status-Code: 400
    DeletionOfValueNotAllowed = 5024, // Http-Status-Code: 400
    UsedInStampsAsSingleUse = 5025, // Http-Status-Code: 400
    UsedForDocTypeLevelDuplicatesCheck = 5026, // Http-Status-Code: 400
    ErrorMovingIsKeyProp = 5027, // Http-Status-Code: 400
    ErrorRequiredForDuplicateCheck = 5028, // Http-Status-Code: 400
    InvalidDateTagDefinitionFormat = 5029, // Http-Status-Code: 400
    ReferencedDateTagDefinitionNotFound = 5030, // Http-Status-Code: 400
    InvalidDefaultValue = 5031, // Http-Status-Code: 400
    SelectionTagDefinitionNodeNotFound = 5032, // Http-Status-Code: 400
    InvalidSelectionTagDefinitionNodeIds = 5033, // Http-Status-Code: 400
    SelectionTagDefinitionNodesNotFound = 5034, // Http-Status-Code: 400
    SelectionTagDefinitionNodesCannotBeOrdered = 5035, // Http-Status-Code: 400
    SelectionTagDefinitionIsDerived = 5036, // Http-Status-Code: 400
    TagGroupDefinitionNotFound = 5037, // Http-Status-Code: 400
    InvalidTagDefinitionIds = 5038, // Http-Status-Code: 400
    TagDefinitionsNotFound = 5039, // Http-Status-Code: 400
    InvalidTagDefinitionSourceType = 5040, // Http-Status-Code: 400
    NotSingleTag = 5041, // Http-Status-Code: 400
    InvalidTagType = 5042, // Http-Status-Code: 400
    TagDefinitionAddRuleIsViolated = 5043, // Http-Status-Code: 400

    // CLASSIFICATION SECTION
    DocumentTypeCategoryNotFound = 6000, // Http-Status-Code: 400
    DocumentTypeNotFound = 6001, // Http-Status-Code: 400
    DocumentTypeAlreadyAssignedToTagGroupDefinition = 6002, // Http-Status-Code: 400
    DocumentTypeToTagGroupDefinitionAssignmentNotFound = 6003, // Http-Status-Code: 400
    PropertyGroupDefinitionIsMulti = 6004, // Http-Status-Code: 400

    // SEARCH SECTION
    SearchResultsNotFound = 7000, // Http-Status-Code: 400
    ConditionNotFound = 7001, // Http-Status-Code: 400
    SearchQueryNotFound = 7002, // Http-Status-Code: 400

    // USER SECTION
    InvalidUserId = 8000, // Http-Status-Code: 400
    WrongCaptcha = 8001, // Http-Status-Code: 400
    UserAlreadyExists = 8002, // Http-Status-Code: 400
    ErrorSendingEMail = 8003, // Http-Status-Code: 500
    ReachedMaximumUsers = 8004, // Http-Status-Code: 403
    MaxReadonlyUsersReached = 8005, // Http-Status-Code: 403
    NotMatchingPasswordPolicy = 8006, // Http-Status-Code: 400
    Prohibited = 8007, // Http-Status-Code: 400
    UserSidAlreadyInUse = 8008, // Http-Status-Code: 400
    WrongUserName = 8009, // Http-Status-Code: 400
    UserNotFound = 8010, // Http-Status-Code: 400
    LoggedOnAtOtherInstance = 8011, // Http-Status-Code: 400
    OrganisationLicenseExpired = 8012, // Http-Status-Code: 403
    LoggedOnAtOtherOrganisation = 8013, // Http-Status-Code: 400

    // USER GROUP SECTION
    UserGroupNotFound = 9000, // Http-Status-Code: 400
    UserGroupMemberNotFound = 9001, // Http-Status-Code: 400
    UserIsAlreadyMemberOfUserGroup = 9002, // Http-Status-Code: 400

    // ANNOTATION SECTION
    UnknownAnnotationType = 10000, // Http-Status-Code: 400
    AnnotationAlreadySaved = 10001, // Http-Status-Code: 400
    AnnotationNotFound = 10002, // Http-Status-Code: 400
    SignatureCannotBeDeleted = 10003, // Http-Status-Code: 400
    SignatureCannotBeChanged = 10004, // Http-Status-Code: 400
    InvalidPropertyChanged = 10005, // Http-Status-Code: 400

    // WEBLINK SECTION
    WebLinkNotFound = 11000, // Http-Status-Code: 400
    ValidationExpired = 11001, // Http-Status-Code: 400
    InvalidUserLink = 11002, // Http-Status-Code: 400
    LinkAlreadyExists = 11003, // Http-Status-Code: 400
    WebLinksNotEnabled = 11004, // Http-Status-Code: 400
    InvalidWebLinkPassword = 11005, // Http-Status-Code: 400

    // FAVORITE SECTION
    FavoriteAlreadyExists = 12000, // Http-Status-Code: 400

    // CLICK-FINDER SECTION
    ClickFinderNodeNotFound = 13000, // Http-Status-Code: 400

    // SOLUTION-STORE SECTION
    SolutionNotAvailable = 14000, // Http-Status-Code: 400
    CheckFailed = 14001, // Http-Status-Code: 400
    AlreadyExists = 14002, // Http-Status-Code: 400

    // ORGANISATION SECTION
    OrganisationNotFound = 15000, // Http-Status-Code: 400
    InvalidOrganisationState = 15001, // Http-Status-Code: 400
    OrganisationMemberNotFound = 15002, // Http-Status-Code: 403
    InactiveOrganisationMember = 15003, // Http-Status-Code: 403

    //SERVER SECTION
    ServerMaintenance = 16000 // Http-Status-Code: 400
}
